import { render, staticRenderFns } from "./RelatorioVenCheckInOutListRoute.vue?vue&type=template&id=56721536"
import script from "./RelatorioVenCheckInOutListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioVenCheckInOutListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports